import { render, staticRenderFns } from "./resultAmend.vue?vue&type=template&id=1777d925&scoped=true&"
import script from "./resultAmend.vue?vue&type=script&lang=js&"
export * from "./resultAmend.vue?vue&type=script&lang=js&"
import style0 from "./resultAmend.vue?vue&type=style&index=0&id=1777d925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1777d925",
  null
  
)

export default component.exports